<template>
	<information-card
		title="Escoje tus factores"
		sub-title="Instructivo"
	>
		<div slot="content">
			<p>La presente herramienta se aplica con el fin de recabar datos y opiniones de los talentos humanos de la organización con el fin de diagnosticar.
			El clima laboral de la organización de la referencia. Es de alta utilidad en planificación, gestión y desarrollo organizacional.</p>
			<p>
			Está diseñada para trabajarla con todo tipo de personal administrativo, técnico y directivo; por lo cual se recomienda mínimo un nivel de bachillerato.
			Se recomienda leer todo este instructivo y proceder conforme se sugiere.
			Si necesita mayor información favor dirigirse a: info@godsulting.com.</p>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn class="custom-button black" @click="back">Atrás</v-btn>
			<v-btn class="custom-button" color="primary" @click="next" :disabled="!nextIsEnabled">Siguiente</v-btn>
		</div>
	</information-card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'ValuationModelDescriptionNavigation',
	components: { InformationCard, Card },
	props: ['nextIsEnabled', 'selectedFactors'],
	methods: {
		next() {
			this.goTo('job-supply-valuation-model-factors-weighting');
		},
		back() {
			this.goTo('job-evaluation-supplies');
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation.vue